export default "__VITE_ASSET__BFC01C$$__"